import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "duplicate_note" }
const _hoisted_2 = { class: "duplicate_note__table" }
const _hoisted_3 = { class: "duplicate_note__table-header" }
const _hoisted_4 = { class: "duplicate_note__table-row" }
const _hoisted_5 = { class: "duplicate_note__room-name" }
const _hoisted_6 = { class: "duplicate_note__checkbox-container" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { colspan: "2" }
const _hoisted_9 = { class: "duplicate_note__no_rooms" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "duplicate_note__table-row" }
const _hoisted_13 = { class: "duplicate_note__room-name" }
const _hoisted_14 = { style: {"display":"flex"} }
const _hoisted_15 = { class: "duplicate_note__checkbox-container" }
const _hoisted_16 = { class: "duplicate_note__room-gender-container" }
const _hoisted_17 = { class: "duplicate_note__room-name-value" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = {
  key: 0,
  class: "duplicate_note__ordered-indicator"
}
const _hoisted_20 = { class: "duplicate_note__room-settings" }
const _hoisted_21 = { class: "duplicate_note__project-settings-image-list" }
const _hoisted_22 = ["src"]
const _hoisted_23 = {
  key: 0,
  class: "duplicate_note__footer"
}
const _hoisted_24 = { class: "duplicate_note__room-count" }
const _hoisted_25 = { class: "duplicate_note__num-selected" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_hadrianCheckbox = _resolveComponent("hadrianCheckbox")!
  const _component_hadrianLoader = _resolveComponent("hadrianLoader")!
  const _component_hadrianToiletType = _resolveComponent("hadrianToiletType")!
  const _component_hadrianTooltip = _resolveComponent("hadrianTooltip")!
  const _component_h_pagination = _resolveComponent("h-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", _hoisted_3, [
        _createElementVNode("tr", _hoisted_4, [
          _createElementVNode("th", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_hadrianCheckbox, {
                value: _ctx.allSelected,
                onChange: _ctx.toggleSelection,
                noMargins: true,
                inverted: true,
                labelClass: "duplicate_note__table-header-checkbox-label",
                label: _ctx.$t('roomDesigner.notes.duplicate.modal.select_all'),
                disabled: !this.hasRooms
              }, null, 8, ["value", "onChange", "label", "disabled"])
            ])
          ]),
          _cache[1] || (_cache[1] = _createElementVNode("th", { class: "duplicate_note__room-settings duplicate_note__left-aligned-header" }, null, -1))
        ])
      ]),
      (!_ctx.hasRooms)
        ? (_openBlock(), _createElementBlock("tbody", _hoisted_7, [
            _createVNode(_component_hadrianLoader, {
              isLoading: _ctx.loading,
              semiTransparent: ""
            }, null, 8, ["isLoading"]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  (!_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.$t('roomDesigner.notes.duplicate.modal.noRooms')), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.shownRooms, (room) => {
            return (_openBlock(), _createElementBlock("tbody", {
              class: _normalizeClass(["duplicate_note__table-body", { disabled: !_ctx.isSelectable(room) }]),
              key: room.id,
              onClick: ($event: any) => (_ctx.selectRoom(room))
            }, [
              _createElementVNode("tr", _hoisted_12, [
                _createElementVNode("td", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_hadrianCheckbox, {
                        value: _ctx.isSelected(room.id),
                        disabled: !_ctx.isSelectable(room),
                        noMargins: "",
                        readOnly: ""
                      }, null, 8, ["value", "disabled"])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_hadrianTooltip, {
                        tooltipText: _ctx.roomTypeLabel(room),
                        enabled: true,
                        anchor: "center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_hadrianToiletType, {
                            class: "duplicate_note__gender-image",
                            toiletType: _ctx.getGenderIcon(room)
                          }, null, 8, ["toiletType"])
                        ], undefined, true),
                        _: 2
                      }, 1032, ["tooltipText"])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("span", null, _toDisplayString(room.roomName), 1),
                      (room.floor)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.$t('roomDesigner.notes.duplicate.modal.floor') + room.floor), 1))
                        : _createCommentVNode("", true)
                    ]),
                    (room.orderInformation_IsOrdered)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, "ORDERED"))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("td", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projectSettingsPictures(room), (projectSetting, i) => {
                      return (_openBlock(), _createBlock(_component_hadrianTooltip, {
                        key: i,
                        enabled: true,
                        tooltipText: projectSetting.label,
                        anchor: "center",
                        wrapperClass: "duplicate_note__project-settings-image-wrapper"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            class: "duplicate_note__settings-image",
                            src: projectSetting.image
                          }, null, 8, _hoisted_22)
                        ], undefined, true),
                        _: 2
                      }, 1032, ["tooltipText"]))
                    }), 128))
                  ])
                ])
              ])
            ], 10, _hoisted_11))
          }), 128))
    ]),
    (_ctx.hasRooms)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("span", _hoisted_24, [
            _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.numSelectedRooms) + "/" + _toDisplayString(_ctx.rooms.length), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('orders.numRoomsSelected')), 1)
          ]),
          _createVNode(_component_h_pagination, {
            class: "duplicate_note__pagination",
            total: _ctx.rooms.length,
            perPage: _ctx.perPage,
            modelValue: _ctx.currentPage,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentPage) = $event)),
            align: "end",
            withBorder: true
          }, null, 8, ["total", "perPage", "modelValue"])
        ]))
      : _createCommentVNode("", true)
  ]))
}